import React from 'react';

/**
 * Displays a link with text "Medicare Advantage plan". On clicking or hovering the link, the Medicare Advantage plan
 * description will display in a pop-over.
 */
export default function MedicareAdvantagePopover() {
	const showPopover = (event) => {
		event && event.preventDefault();
		let popover = window.$(event.currentTarget).data('bs.popover');
		if (!popover) {
			let description = `A form of Medicare coverage that is administered by private insurance companies such as Blue Cross and Blue Shield, Aetna, etc. which replaces the patient's traditional Medicare coverage.`;

			const popoverOptions = {
				content: description,
				html: false,
				placement: 'bottom',
				trigger: 'hover click',
				container: '#reactRoot .banner.section'
				//template: '<div class="popover popover-large" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
			};

			window.$(event.currentTarget).popover(popoverOptions);
		}
		window.$(event.currentTarget).popover('show');
	};

	return (
		<a
			href="# "
			onClick={(e) => {
				showPopover(e);
			}}
		>
			Medicare Advantage plan
		</a>
	);
}
